import {ProductColorBubble} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/product_color.types';

export const mapColorBubbles = (colorBubbles: ProductColorBubble[]) => {
  return colorBubbles.map(colorBubble => {
    let colors: Array<{
      hexCode: string;
      isLightColor?: boolean;
    }> = [];

    if (colorBubble.color?.$case === 'gradient') {
      colors = colorBubble.color.gradient.hexCodes.map(code => ({
        hexCode: code,
      }));
    } else if (colorBubble.color?.$case === 'simple') {
      colors = colorBubble.color.simple.colors.map(code => ({
        hexCode: code.hexCode,
        isLightColor: code.isLightColor,
      }));
    }

    return {
      colors,
      type: colorBubble.color?.$case ?? 'simple',
      productId: colorBubble.productId,
    };
  });
};
